import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import { Spark } from "@/components/Doodles";

const PaymentCancel = () => (
    <div className="flex min-h-screen items-center justify-center bg-brick px-5 py-24">
        <Seo title="Payment" description="Panther City Clubhouse membership payment." />
        <div data-testid="payment-cancel" className="max-w-lg border-2 border-ink bg-cream p-10 text-center hard-shadow-lg rotate-1">
            <Spark className="mx-auto h-10 w-10 text-mustard" />
            <h1 className="mt-3 font-display text-4xl tracking-wide text-ink">NO HARM, NO FOUL.</h1>
            <p className="mt-4 leading-relaxed text-ink/80">
                The checkout got abandoned somewhere between here and the card field. Happens to the best of us. Your wallet is untouched
                and the clubhouse door is still open.
            </p>
            <p className="mt-4 font-hand text-2xl text-brick -rotate-2">the tiers aren't going anywhere.</p>
            <Link to="/membership" data-testid="payment-cancel-back" className="btn-stamp mt-6">
                Back to Membership
            </Link>
        </div>
    </div>
);

export default PaymentCancel;
